
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'generalInfo': 'Жалпы',
	'widgetId': 'Виджет идентификаторы',
	'widgetType': 'Виджет түрі',
	'serviceability': 'Қызмет ету мүмкіндігі',
	'copyButton': 'Көшіру',
	'closeButton': 'Жабу',
	'specification': 'Спецификация',
	'viewSpecification': 'Көрініс сипаттамасы'
});
